<template lang="pug">
  .wrapper
    .tabs(:style="`width: ${width}`")
      RadioSlider(:items="tabsNames", :current="currentIndex", @selected="selectTab")

    .tabs-details
      slot

</template>

<script>
import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'
import RadioSlider from './RadioSlider'

export default {
  name: 'Tabs',
  mixins: [handlerUseStateVmodel()],
  components: { RadioSlider },
  props: {
    width: { type: String, default: '50%' }
  },
  data () {
    return {
      tabs: []
    }
  },
  computed: {
    state: {
      get () {
        return this.__state
      },
      set (val) {
        this.tabs.forEach(i => {
          i.isActive = i.name === val
        })
        this.__state = val
      }
    },
    currentIndex () {
      return this.tabs.findIndex(i => i.name === this.state)
    },
    tabsNames () {
      return this.tabs.filter(i => i)
    }
  },
  created () {
  },
  mounted () {
    this.tabs = this.$children.filter(i => i.$options.name === 'Tab')
    this.tabs.forEach(i => {
      i.isActive = i.name === this.__state
    })
  },
  methods: {
    selectTab (item) {
      this.state = item.name
    }
  }
}
</script>

<style scoped lang="scss">
</style>
